
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import NewsletterFeaturedIssue from './NewsletterFeaturedIssue';

const NewsletterHero = () => {
  const latestIssue = {
    date: '2025-04-11',
    title: 'AI is making human skills 54x more desirable',
    url: 'https://pub.mailmodo.site/p/x9LLgnnbc8',
    image: 'https://res.cloudinary.com/mailmodo/image/upload/ar_1200:879,c_crop/v1744373547/editor/p/f5db4dc5-6469-439e-af13-feb5f84053ee/37e944f5ab2a61a731c976354038ea95_txfbwj.png',
    highlights: [
      'Emerging roles in AI that are reshaping the tech landscape',
      'Remote work trends and how companies are adapting',
      '5 skills that will be in high demand for tech roles in 2025'
    ]
  };

  return (
    <section className="py-20 md:py-28">
      <div className="container px-4 md:px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div className="space-y-6 animate-fade-in">
          <div className="inline-block px-3 py-1 bg-neutral-light rounded-full text-sm text-secondary-dark font-medium">
            Sent with ❤️ every Friday
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
            The <span className="highlight">Talent Tales</span>
          </h1>
          <p className="text-xl text-secondary-dark max-w-md">
            The talent market is noisy. Get real insights from thousands of hiring companies and millions of premium candidates in your inbox.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="https://cutshort.io/a/newsletter-hs-form" target="_blank" rel="noopener noreferrer">
              <Button className="bg-primary hover:bg-primary-light text-white px-8 py-6 text-lg">
                Subscribe Now
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </a>
            <Button 
              variant="outline" 
              className="border-primary text-primary hover:bg-primary-light hover:text-white px-8 py-6 text-lg"
              onClick={() => document.getElementById('past-issues')?.scrollIntoView({ behavior: 'smooth' })}
            >
              View Past Issues
            </Button>
          </div>
          <p className="text-sm text-gray-600">
            Based on real data from 3.5 Million users and 40,000+ recruiters who have signed up on <a href="https://cutshort.ai" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">Cutshort</a>.
          </p>
        </div>
        <div className="relative">
          <div className="absolute -top-4 -left-4 h-24 w-24 bg-accent rounded-full opacity-60 blur-xl"></div>
          <div className="absolute -bottom-8 -right-8 h-32 w-32 bg-primary/30 rounded-full opacity-60 blur-xl"></div>
          <NewsletterFeaturedIssue {...latestIssue} />
        </div>
      </div>
    </section>
  );
};

export default NewsletterHero;

